<article
  class="doc-card"
  [class.doc-card--disabled]="disabled"
  [attr.role]="disabled ? null : 'button'"
  [attr.aria-label]="documento?.nome"
  [attr.aria-disabled]="disabled"
  [attr.tabindex]="disabled ? -1 : 0"
  (click)="!disabled && goToPreview()"
  (keydown.enter)="!disabled && goToPreview()"
  (keydown.space)="!disabled && goToPreview()">
  <!-- Tag -->
  <ds-tooltip-trigger
    [attr.tooltip-position]="'top'"
    [attr.tooltip-text]="tagLabel | translate"
    [attr.z-index]="999">
    <div class="ff-body-s ff-bold doc-card__tag rem-bottom-05" *ngIf="tagLabel">
      {{ tagLabel | translate }}
    </div>
  </ds-tooltip-trigger>

  <!-- Title H4 (usiamo H4 token) -->
  <ds-tooltip-trigger
    [attr.tooltip-position]="'top'"
    [attr.tooltip-text]="documento?.nome"
    [attr.z-index]="999">
    <h4 class="ff-title-2xs ff-bold doc-card__title rem-bottom-05">{{ documento?.nome }}</h4>
  </ds-tooltip-trigger>

  <!-- Order / Position stacked (Body 1 sizes) -->
  <div class="doc-card__meta">
    <div class="meta-row rem-bottom-05">
      <ds-output
        [attr.output-arialabel]="orderLabel"
        [attr.output-title-arialabel]="orderLabel"
        [attr.is-horizontal]="true"
        [attr.output-title]="orderLabel"
        [attr.output-text]="documento?.numeroOrdine"
        [attr.output-title-tag]="'span'"
        [attr.output-text-tag]="'span'"
        ></ds-output>
         </div>
    <div class="meta-row rem-bottom-075">
      <ds-output
        [attr.output-arialabel]="positionLabel"
        [attr.output-title-arialabel]="positionLabel"
        [attr.is-horizontal]="true"
        [attr.output-title]="positionLabel"
        [attr.output-text]="documento?.codicePosizione"
        [attr.output-title-tag]="'span'"
        [attr.output-text-tag]="'span'"
        ></ds-output>
    </div>
  </div>

  <!-- Footer: avatar + supplier label (two-line) -->
  <div class="doc-card__footer">
    <div class="avatar" aria-hidden="true">
      <div class="avatar__circle">
        <ds-avatar
          [attr.avatar-type]="'initial'"
          [attr.full-name]="
            documento?.ruolo.nome + ' ' + documento?.ruolo.cognome
          "
          [attr.avatar-size]="'small'"></ds-avatar>
      </div>
    </div>

    <div class="supplier">
      <div class="ff-body-s ff-bold color-primary">
        {{
          (avatarLabel.split(':')[0] | translate) ||
            (documento?.ruolo | translate)
        }}:
      </div>
      <div class="ff-body-s ff-bold color-primary">
        <ng-container *ngIf="avatarLabel.includes(':'); else whole">
          {{ avatarLabel.split(':')[1]?.trim() }}
        </ng-container>
        <ng-template #whole>{{ avatarLabel }}</ng-template>
      </div>
    </div>
  </div>
</article>
